import styled from "styled-components";
import TableContainer from '@mui/material/TableContainer';

export const StyledTableContainer = styled(TableContainer)`
    box-shadow: 1px 2px 6px 0px rgba(37, 62, 145, 0.17) !important;
`

export const HeaderTypography = styled.div`
    text-align: left;
    text-transform: uppercase;
    font-size: 12px;
    font-weight: 600 !important;
    font-family: Hind Vadodara, Lucida Sans Unicode !important;
    letter-spacing: 0.8px;
`

export const DataTypography = styled.div`
    text-align: left;
    font-size: 14px;
    font-family: Hind Vadodara, Lucida Sans Unicode !important;
    letter-spacing: 0.8px;
    color: #a1a1a1;
    font-weight: 400;
    line-height: 1.5;
`